import type { DevUserDto } from '@/api';
import { Table, Tag } from '@lego/connect-components-react';
import { Flex, Text } from '@lego/klik-ui';
import { CompactTable } from './compact-table';

type Props = {
  users: DevUserDto[];
};

/** All users with their IDs, names, e-mails and roles. */
export const UsersTable = ({ users }: Props) => {
  if (users.length === 0) {
    return <Text>No users.</Text>;
  }

  return (
    <CompactTable ariaLabel="Users">
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell>User Id</Table.HeaderCell>
          <Table.HeaderCell>Name</Table.HeaderCell>
          <Table.HeaderCell>Email</Table.HeaderCell>
          <Table.HeaderCell>Roles</Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {users.map((user) => (
          <Table.Row key={user.userId}>
            <Table.Cell>
              <code>{user.userId}</code>
            </Table.Cell>
            <Table.Cell>{user.name}</Table.Cell>
            <Table.Cell>{user.email || '-'}</Table.Cell>
            <Table.Cell>
              {user.roles.length === 0 ? (
                '-'
              ) : (
                <Flex gap={1} flexWrap="wrap">
                  {user.roles.map((role) => (
                    <Tag key={role} size="small" variant="neutral">
                      {role}
                    </Tag>
                  ))}
                </Flex>
              )}
            </Table.Cell>
          </Table.Row>
        ))}
      </Table.Body>
    </CompactTable>
  );
};
